import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

const ClubIcon = (props) => (
  <SvgIcon
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="52"
    height="60"
    viewBox="0 0 52 60"
    fill="none">
    <g clipPath="url(#clip0_13974_95310)">
      <path
        d="M51.5874 13.1688V0H0V14.1447H0.0309511V45.1077L25.8155 59.9997L51.6003 45.1077V13.1688H51.5877H51.5874Z"
        fill="white"
      />
      <path
        d="M44.5351 35.8427C40.2458 34.3353 33.9005 29.4931 33.9005 29.4931C33.9005 29.4931 36.8182 29.4774 37.7141 29.2804C37.6018 29.2417 33.7028 27.4295 31.5818 25.9336C28.9793 24.0988 28.3583 22.7032 24.5785 22.2462C23.926 22.1676 23.2743 22.0968 22.6321 22.0968C18.6299 22.0968 15.8139 23.9996 14.4914 25.1337C13.8334 25.6982 13.3889 26.0279 13.3889 26.0279C13.3889 26.0279 11.2143 26.1125 8.98723 26.9505C7.93059 27.3478 7.54858 27.8002 7.27374 28.3661C6.80489 29.3297 7.41789 31.8488 7.44283 31.8336C11.3315 29.4335 18.2482 31.858 18.7176 32.723C18.0734 30.9945 15.4273 29.2233 15.4273 29.2233C15.4273 29.2233 19.5212 30.1425 20.5168 33.7433C21.5293 37.4063 16.8488 38.9289 16.5742 39.068C18.3044 39.0284 23.3293 37.8048 23.3293 37.8048C23.3293 37.8048 23.2815 38.6907 23.0949 39.3432C24.1469 38.8888 26.4175 37.7403 26.4175 37.7403C26.4175 37.7403 32.3378 38.8613 34.6393 39.0261C33.0586 38.1328 31.3754 36.4402 31.1897 36.1586C31.1897 36.1586 38.4094 37.7721 40.8453 38.2174C39.2479 37.2509 37.7473 35.4018 37.6585 35.2948C37.6585 35.2948 41.7512 36.0239 44.5351 35.8427ZM17.5197 26.7223C15.4955 26.4554 15.6431 25.8287 15.6431 25.8287L21.0622 24.8875C21.0622 24.8875 18.2843 26.8232 17.5197 26.7223Z"
        fill="black"
      />
      <path
        d="M9.17458 9.82225H10.7158V11.377C10.7158 12.1608 10.0868 12.7901 9.30326 12.7901H6.41335C5.63011 12.7901 5.01367 12.1608 5.01367 11.377V5.64692C5.01367 4.8634 5.63011 4.23383 6.41335 4.23383H9.30326C10.0868 4.23383 10.7158 4.8634 10.7158 5.64692V7.12451H9.17458V5.98091C9.17458 5.78825 9.0204 5.64692 8.82782 5.64692H6.90169C6.70882 5.64692 6.55492 5.78825 6.55492 5.98091V11.0427C6.55492 11.2356 6.7091 11.3767 6.90169 11.3767H8.82782C9.02069 11.3767 9.17458 11.2356 9.17458 11.0427V9.82197V9.82225Z"
        fill="black"
      />
      <path
        d="M17.1367 4.23352H18.678V11.3767H22.1711V12.7898H17.1367V4.23352Z"
        fill="black"
      />
      <path
        d="M32.3074 4.23352H33.8486V11.3767C33.8486 12.1605 33.2196 12.7898 32.4361 12.7898H29.5462C28.7629 12.7898 28.1465 12.1605 28.1465 11.3767V4.23352H29.6877V11.0427C29.6877 11.2356 29.8419 11.3767 30.0345 11.3767H31.9606C32.1535 11.3767 32.3074 11.2356 32.3074 11.0427V4.23352Z"
        fill="black"
      />
      <path
        d="M40.3343 4.23352H44.5594C45.3171 4.23352 45.9207 4.83729 45.9207 5.58268V7.41978C45.9207 7.80509 45.6381 8.22911 45.2397 8.35783C45.5994 8.42205 45.9848 8.78155 45.9848 9.28297V11.4415C45.9848 12.1863 45.381 12.7903 44.6233 12.7903H40.334V4.23352H40.3343ZM44.0713 7.71507C44.251 7.70246 44.3797 7.56083 44.3797 7.38137V5.96799C44.3797 5.77533 44.2255 5.63428 44.0332 5.63428H41.8755V7.71536H44.0716L44.0713 7.71507ZM41.8755 11.3899H44.0971C44.29 11.3899 44.4439 11.2485 44.4439 11.0556V9.43721C44.4439 9.24427 44.2897 9.10293 44.0971 9.10293H41.8755V11.3901V11.3899Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_13974_95310">
        <rect width="51.6" height="60" fill="white" />
      </clipPath>
    </defs>
  </SvgIcon>
);

export default ClubIcon;
